import React from 'react'
import css from './chart.module.scss'

export const Tooltip: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <div className={css.tooltip_wrapper}>{children}</div>
)
